import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from "../ActionButtons";
// import AskCancelModal from "../AskCancelModal";

import { standardWeight_Tripper } from '../../../lib/data/standard-weight';

const TripperForm = ({ onSaveStructure, onChangeWeightSummary, trippers, beltWidth }) => {
    const [isShow, setIsShow] = useState(trippers?.length || false);
    const [newTripper, setNewTripper] = useState(trippers || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    // const [length, setLength] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /*  처음 props로 넘어온 trippers를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialtripper = useRef(trippers || []);

    /* 벨트폭에 해당하는 Weight를 가져온다. */
    useEffect(() => {
        if (!standardWeight_Tripper || !beltWidth) return;
        const library = standardWeight_Tripper.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        const _standardWeight = library.standardWeight;
        const _unitWeight = Math.ceil(_standardWeight * factor);

        setStandardWeight(_standardWeight);
        setUnitWeight(_unitWeight);
    }, [beltWidth, factor]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!unitWeight || !qty) {
        //     return;
        // }
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 중량 계산 */

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newTripper.length) {
            return 0;
        }
        return Math.max(...newTripper.map((item) => Number(item.id.substring(3))), 0);
    }, [newTripper]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`TR-${getLastId() * 1 + 1}`);
        // setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newTripper에 tripper 추가 */
    const onAddTripper = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const tripper = {
            id,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewTripper((prev) => [...prev, tripper]);
        setIsChanged(true);
    }, [factor, id, qty, standardWeight, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 tripper 삭제 */
    const onDeleteTripper = useCallback((id) => {
        setNewTripper((prev) => prev.filter((tripper) => tripper.id !== id));
        setIsChanged(true);
    }, []);

    /* newTripper에 변화가 생기면  리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newTripper);
        getTotalWeight(newTripper);
        initializeForm();
        onSaveStructure({
            key: 'tripper',
            value: newTripper,
        });
        onChangeWeightSummary({
            key: 'tripper',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newTripper,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveTripper = useCallback(() => {
    //     onSaveStructure({
    //         key: 'tripper',
    //         value: newTripper,
    //     });
    //     onChangeWeightSummary({
    //         key: 'tripper',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newTripper, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newTripper를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewTripper(initialtripper.current);
    //     onSaveStructure({
    //         key: 'tripper',
    //         value: initialtripper.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'tripper',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <TripperFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Tripper</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Standard W't <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newTripper &&
                                newTripper.map((tripper, index) => (
                                    <tr key={index}>
                                        <td>{tripper.id}</td>
                                        <td>{tripper.standardWeight}</td>
                                        <td>{tripper.factor}</td>
                                        <td>{tripper.unitWeight}</td>
                                        <td>{tripper.qty}</td>
                                        <td>{tripper.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteTripper(tripper.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                {/* <td><StyledInput readOnly value={unitWeight} /></td> */}
                                {/* <td><StyledInput readOnly value={weight}  /></td> */}
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddTripper}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={3}>Tripper Frame Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveTripper} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </TripperFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const TripperFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }

    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default TripperForm;
